
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customfiltrarporcategoriatt81a_6966b8f1a85c3d434df2bdda } from '../../api/camisas.api'

import './catalogo.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pcatalogo = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {
	const [loftystate_categoriavtfn1, set_loftystate_categoriavtfn1] = useState()

	const [loftyres_6966b8f1a85c3d434df2bdda_component_if0a5w, setloftyres_6966b8f1a85c3d434df2bdda_component_if0a5w] = useState([]);
	const [loftyres_6966b8f1a85c3d434df2bdda_component_it6a0n, setloftyres_6966b8f1a85c3d434df2bdda_component_it6a0n] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customfiltrarporcategoriatt81a_6966b8f1a85c3d434df2bdda({
					categoriadnbjlj: `camisas`,
				});
				setloftyres_6966b8f1a85c3d434df2bdda_component_if0a5w(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customfiltrarporcategoriatt81a_6966b8f1a85c3d434df2bdda({
					categoriadnbjlj: `camisaspolo`,
				});
				setloftyres_6966b8f1a85c3d434df2bdda_component_it6a0n(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id692858a5c419e6f0648ca229" >

      <div id="iiyb" className="">
      
      <div id="im6f" className="">
      
      <div id="is4uc" className="">
      
      <img
        className=""
        id="icmn6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhky00z2.png"
        alt="undefined"
      />
      
      <div className="" id="ihbt6">
        <>+504 8805-8638 / +504 8735-8194</>
      </div>
      
      <img
        className=""
        id="ilgyi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhky21kx.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="iaoea"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhky2ofv.png"
        alt="undefined"
      />
      
      <div className="" id="i1fmo">
        <>promomas.tgu@gmail.com</>
      </div>
      
      </div>
      
      </div>
      
      <div id="io8p" className="">
      
      <div id="iz11r" className="">
      
      <img
        className=""
        id="iqh9l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj76tl47.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ipi7" className="">
      
        <a
          target=""
          className=""
          id="i0rt5"
          href="/"
        >
          
    <div id="i5f7n" className="">
    <>Home</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i64qq"
          href="/catalogo"
        >
          
    <div id="i0v2r" className="">
    <>Catalogo</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iyoo9"
          href="/clientes"
        >
          
    <div id="i3bxm" className="">
    <>Clientes  y  Casos</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i366m"
          href="/contacto"
        >
          
    <div id="i3ztl" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      <div id="i2j0h" className="">
      
        <a
          target=""
          className=""
          id="iohmi"
          href="/carritocompras"
        >
          
    <div id="is0ki" className="">
    <>Carrito de Compra</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="izzx8y" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Home</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/catalogo"
        type=""
      >
        <>Catalogo</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/clientes"
        type=""
      >
        <>Clientes  y  Casos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="iwz9d6" className="">
      
      <img
        className=""
        id="igv25h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj76tl47.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iaebgw" className="">
      
        <a
          target=""
          className=""
          id="ipy0ca"
          href="/carritocompras"
        >
          
    <div id="izfo4g" className="">
    <>Carrito de Compra</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div
        id="ikireu"
        className=""
        data-aos="fade-right"
        data-aos-duration="10"
      >
      
      <div id="iw4u9l" className="">
      
      <img
        className=""
        id="iukafk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhm3g3iz.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="iewnc6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhm40xb9.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="i2js7g"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhm3zpz0.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ivfekr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhm40bff.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ii3fb7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhm40134.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="izzw76"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhm40o4f.png"
        alt="undefined"
      />
      
      <div id="iosisl" className="">
      
      <div className="" id="i1oy8v">
        <>Catálogo</>
      </div>
      
      <div className="" id="izg81j">
        <>Explora lo que tenemos para ti:</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icwpcl" className="">
      
      <div id="inr2gg" className="">
      
      <div className="" id="ijty39">
        <>Personalización de impresión fácil y rápida con servicios de impresión digital</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iby3j5" className="">
      
      <div id="iqo0ky" className="">
      
      <img
        className=""
        id="ileghw"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmpqunh.png"
        alt="undefined"
      />
      
      <div className="" id="iut2iv">
        <>CAMISAS</>
      </div>
      
      </div>
      
      </div>
      
      <div id="i0wo6f" className="">
      
      <div id="inah4q" className="">
      
        <div id="iaebfd" className="">
        
      <div id="izl4ih" className="">
      
      <div id="ikjfth" className="">
      
      <div id="iskmml" className="">
      
      </div>
      
      <div id="igywop" className="">
      
        <div className="" id="ivu7oa">
          
      <div id="iactda" className="">
      <>
         &#123;&#123; descripcion &#125;&#125;
        </>
      </div>
      
        </div>
        
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
}}

      >
      
      <div id="is6u55" className="">
      <>Agregar al carrito</>
      </div>
      
      <img
        className=""
        id="idxcdv"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmsew05.png"
        alt="undefined"
      />
      
      </button>
      
      </div>
      
      </div>
      
      </div>
      
        </div>
        
      </div>
      
      </div>
      
      <div
        id="ijf3az"
        className=""
        data-aos="fade-right"
        data-aos-duration="10"
      >
      
      <div id="is7muo" className="">
      
      <div id="ipl62l" className="">
      
        <div id="if0a5w" className="">
        
            {
              loftyres_6966b8f1a85c3d434df2bdda_component_if0a5w.map((loftyitem_6966b8f1a85c3d434df2bdda_component_if0a5w) => (
                <div key={loftyitem_6966b8f1a85c3d434df2bdda_component_if0a5w._id} className="" id="iaeflp">
                  
      <div id="i21p1h" className="">
      
      <div id="i58wss" className="">
      
        <img
          className=""
          id="iw6skg"
          alt=""
          src={loftyitem_6966b8f1a85c3d434df2bdda_component_if0a5w.loftyUrl}
        />
        
      </div>
      
      <div id="ir0s6g" className="">
      
        <div className="" id="i08jsd">
          
          <div className="" id="ia3p7v">
            {loftyitem_6966b8f1a85c3d434df2bdda_component_if0a5w?.descripcion}
          </div>
          
        </div>
        
        <a
          target=""
          className=""
          id="ityxe9"
          href={`/producto/${loftyitem_6966b8f1a85c3d434df2bdda_component_if0a5w._id}`}
        >
          
    <div id="iocwi7" className="">
    
      <span className="" id="iz2s2w">
        <>Agregar al carrito</>
      </span>
      
    </div>
    
      <img
        className=""
        id="ifmenl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmsew05.png"
        alt="undefined"
      />
      
        </a>
        
      <button
        type=""
        name=""
        id="il2a18"
        className="standard_button "
        onClick={async () => {
}}

      >
      
      <div id="ix2ctg" className="">
      <>Agregar al carrito</>
      </div>
      
      <img
        className=""
        id="i6un52"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmsew05.png"
        alt="undefined"
      />
      
      </button>
      
      </div>
      
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="idtuqg" className="">
      
      <div id="ianv34" className="">
      
      <img
        className=""
        id="i4zn97"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnrn4iz.png"
        alt="undefined"
      />
      
      <div className="" id="ipu9gc">
        <>CAMISAS POLO</>
      </div>
      
      </div>
      
      </div>
      
      <div
        id="i76mri"
        className=""
        data-aos="fade-right"
        data-aos-duration="10"
      >
      
      <div id="i2zbnv" className="">
      
      <div id="i77k4j" className="">
      
        <div id="it6a0n" className="">
        
            {
              loftyres_6966b8f1a85c3d434df2bdda_component_it6a0n.map((loftyitem_6966b8f1a85c3d434df2bdda_component_it6a0n) => (
                <div key={loftyitem_6966b8f1a85c3d434df2bdda_component_it6a0n._id} className="" id="i2m9yh">
                  
      <div id="ifhthk" className="">
      
      <div id="i4r1nj" className="">
      
        <img
          className=""
          id="i9pzu5"
          alt=""
          src={loftyitem_6966b8f1a85c3d434df2bdda_component_it6a0n.loftyUrl}
        />
        
      </div>
      
      <div id="idf51g" className="">
      
        <div className="" id="i86p4g">
          
          <div className="" id="">
            {loftyitem_6966b8f1a85c3d434df2bdda_component_it6a0n?.descripcion}
          </div>
          
        </div>
        
        <a
          target=""
          className=""
          id="iie39k"
          href={`/producto/${loftyitem_6966b8f1a85c3d434df2bdda_component_it6a0n._id}`}
        >
          
    <div id="il96px" className="">
    
      <span className="" id="io4wve">
        <>Agregar al carrito</>
      </span>
      
    </div>
    
      <img
        className=""
        id="i5tn2m"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmsew05.png"
        alt="undefined"
      />
      
        </a>
        
      <button
        type=""
        name=""
        id="i8dkow"
        className="standard_button "
        onClick={async () => {
}}

      >
      
      <div id="" className="">
      <>Agregar al carrito</>
      </div>
      
      <img
        className=""
        id="iy0pj2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmsew05.png"
        alt="undefined"
      />
      
      </button>
      
      </div>
      
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div
        id="ipqkmv"
        className=""
        data-aos="fade-right"
        data-aos-duration="10"
      >
      
      <div id="iq0tah" className="">
      
      <div id="ie1mo2" className="">
      
      <div className="" id="i3fm72">
        <>Empresas Que Confian En Nosotros</>
      </div>
      
      </div>
      
      <div id="ii2lyj" className="">
      
      <div id="ipfn1t" className="">
      
      <img
        className=""
        id="iov5sj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmupjd5.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iau5z6" className="">
      
      <img
        className=""
        id="i7xm0f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmur15k.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iad8zj" className="">
      
      <img
        className=""
        id="if1spy"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmurbwf.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ipc4zq" className="">
      
      <img
        className=""
        id="i0w7en"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhmurm3i.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ixwk4o" className="">
      
      <div id="iiww8m" className="">
      
      <div className="" id="ifv21g">
        <>PROMOMÁS</>
      </div>
      
      </div>
      
      <div id="iqia8d" className="">
      
      <img
        className=""
        id="idg28o"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl8hqoi.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iuttse" className="">
      
      <div id="i25xem" className="">
      
      <div className="" id="imteyo">
        <>Servicios</>
      </div>
      
        <a
          target=""
          className=""
          id="iy78h4"
          href="#"
        >
          
    <div id="izbti2" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i0xii1">
        <>Impresión Digital</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipqz1l"
          href="#"
        >
          
    <div id="inoqdq" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ilmxx8">
        <>Impresión Empresarial</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ir56kh"
          href="#"
        >
          
    <div id="ias9g8" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieztyk">
        <>Impresión Camisas</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="itdtwi"
          href="#"
        >
          
    <div id="i6g3qf" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itz8r7">
        <>Impresión Vinil</>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      <div id="iuud1b" className="">
      
      <div className="" id="i7yb3u">
        <>Links</>
      </div>
      
        <a
          target=""
          className=""
          id="ikbm9q"
          href="#"
        >
          
    <div id="ind5fe" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="icv9sr">
        <>Términos de Uso</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ia59al"
          href="#"
        >
          
    <div id="irnnqo" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="id6hyi">
        <>Política de privacidad</>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      <div id="i73f12" className="">
      
      <div className="" id="i2lbvh">
        <>Contacto</>
      </div>
      
      <div id="i466ik" className="">
      
      <img
        className=""
        id="i62w5l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9awu5.png"
        alt="undefined"
      />
      
      <div className="" id="iewlbx">
        <>+504 8805-8638 / +504 8735-8194</>
      </div>
      
      </div>
      
      <div id="idh5ss" className="">
      
      <img
        className=""
        id="izotfk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9gu29.png"
        alt="undefined"
      />
      
      <div className="" id="izb5r9">
        <>promomas.tgu@gmail.com</>
      </div>
      
      </div>
      
      <div id="iqhlmx" className="">
      
      <img
        className=""
        id="iqw36b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9gu29.png"
        alt="undefined"
      />
      
      <div className="" id="il620y">
        <>Res. El molinón, Tegucigalpa, Honduras</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ip8fzp" className="">
      
      <div className="" id="ichv08">
        <>Ubicación</>
      </div>
      
      <div id="iqgohk" className="">
      
      <iframe
        title="Mapa"
        className=""
        id="io2gc7"
        frameBorder="0"
        src="https://maps.google.com/maps?&q=Res. El molinón, Tegucigalpa, Honduras&z=10&t=q&output=embed"
      />
      
      </div>
      
      </div>
      
      <div id="i5b5b3" className="">
      
      <div className="" id="iz6anw">
        <>Redes Sociales</>
      </div>
      
      <div id="ihi4ns" className="">
      
      <img
        className=""
        id="ijd5dp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9tcox.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="isber5" className="">
      
      <img
        className=""
        id="i69api"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl8hqoi.png"
        alt="undefined"
      />
      
      <div className="" id="iotx6g">
        <>Promomás©2025 Todos los Derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcatalogo);
  